export const TitleSmall = ({children}:{children:React.ReactNode}) => {
    return (
        <h1 className="text-black text-bold break-words max-xl:truncate">{children}</h1>
    )
}

export const Title = ({children}:{children:React.ReactNode}) => {
    return (
        <h1 className="text-black text-bold text-xl break-words truncate">{children}</h1>
    )
}

export const Header = ({children}:{children:React.ReactNode}) => {
    return (
        <h1 className="text-black font-bold text-3xl break-words truncate p-1">{children}</h1>
    )
}
  
